import { ProductDetailsLocationScreen } from '../../../../../screens';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  return <ProductDetailsLocationScreen />;
}
